import styled from "styled-components";

export const StyledWrapperPosteos = styled.div`
  margin-top: 40px;
  padding: 0px;
  h1 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
    margin-left: 70px;
    color: #000000;
  }
  hr {
    height: 6px;
    opacity: 1.25;
    background: #e63457;
  }
  h3 {
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
  }
  .description {
    margin-bottom: 0
  }
  .img-post-grande {
    width: 100%
  }
  a {
    color: black;
  }
  a:hover {
    color: black;
  }
`;
